import React from 'react';
import MUITextField from '@mui/material/TextField';

export type TextFieldProps = {
    name: string;
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    multiline?: boolean;
    maxRows?: number;
    minRows?: number;
};

const TextField = ({ name, multiline, label, value, onChange, ...rest }: TextFieldProps) => {
    return <MUITextField name={name} label={label} multiline={multiline} value={value} onChange={onChange} {...rest} />;
};

export default TextField;
